module.exports = __webpack_public_path__ + "img/9349.e5222772.jpg";